import React from 'react';
import './luckObservation.css'
import './seeMoreAllInHands.css';
import MediaQuery from 'react-responsive';
import TableDeskBody from './TableDeskBody';
import TableSmallBody from './TableSmallBody';
import { getColor, getTextColor } from '../../common/ThemeService';

class TopWonNLoss extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accountName: localStorage.getItem('accountName'),
        }
    }

    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        return (
            <div>
                <div className="centerModal">
                    <div className={`seeMoreAllInHands`}>
                        <div className="seeMoreLuckHeading">
                            <div>Biggest Hands &nbsp;
                                <MediaQuery maxWidth={767} >
                                    <i className="fa fa-times modalCloseButton" onClick={this.props.onCloseSeeMoreHands} data-e2e="handClose"></i>
                                </MediaQuery>
                            </div>
                            <div className="wonLostBtn">
                                <div className={`luckResult ${this.props.activeBtn === 'Won' ? 'luckResultActive' : ''}`} onClick={() => {
                                    this.props.setActiveBtn('Won');
                                }} data-e2e="WON"
                                style={this.props.activeBtn === 'Won' ? {
                                    backgroundColor: themeColor,
                                    color: themeTextColor,
                                } : {}}
                                >WON</div>
                                <div className={`luckResult ${this.props.activeBtn === 'Lost' ? 'luckResultActive' : ''}`} onClick={() => {
                                    this.props.setActiveBtn('Lost');
                                }}data-e2e="LOST"
                                style={this.props.activeBtn === 'Lost' ? {
                                    backgroundColor: themeColor,
                                    color: themeTextColor,
                                } : {}}
                                >LOST</div>
                            </div>
                            <MediaQuery minWidth={768} >
                                <i className="fa fa-times modalCloseButton" onClick={this.props.onCloseSeeMoreHands}></i>
                            </MediaQuery>
                        </div>
                        <div className="seeMoreLuckSubHeading">{this.props.activeBtn === 'Won' ? this.props.subHeadingWon : this.props.subHeadingLost}</div>
                        <MediaQuery minWidth={768} >
                            <div className="seeMoreAllInHandsDivider"></div>
                        </MediaQuery>
                        <div className="topWonNLossLandPage">
                            {
                                this.props.handList.length === 0
                                    ?
                                    <div className="NoAllInHands">
                                        <div className="NoAllInHandsMsg"><center>You haven't {this.props.activeBtn} any game yet.</center></div>
                                    </div>
                                    : <table style={{ width: '100%' }}>
                                        <MediaQuery minWidth={768} >
                                            <thead className="">
                                                <tr className="">
                                                    <th className='topWonLossCard luckModalTh'>Cards</th>
                                                    <th className='topWonLossFlop luckModalTh'>Flop</th>
                                                    <th className='topWonLossTurn luckModalTh'>Turn</th>
                                                    <th className='topWonLossRiver luckModalTh'>River</th>
                                                    <th className='topWonLossProfit luckModalTh'>Profit</th>
                                                    <th className='topWonLossNote luckModalTh'></th>
                                                    <th className='topWonLossStar luckModalTh'></th>
                                                    <th className='topWonLossPlay luckModalTh'></th>
                                                </tr>
                                            </thead>
                                        </MediaQuery>
                                        <MediaQuery maxWidth={767} >
                                            <thead className="">
                                                <tr className="">
                                                    <th className='topWonLossCard '></th>
                                                    <th className='topWonLossProfit '></th>
                                                    <th className='topWonLossNote '></th>
                                                    <th className='topWonLossStar '></th>
                                                    <th className='topWonLossPlay '></th>
                                                </tr>
                                            </thead>
                                        </MediaQuery>
                                        <MediaQuery minWidth={768} >
                                            <tbody>
                                                {this.props.handList.map((hand, i) =>
                                                    <TableDeskBody key={i} hand={hand}
                                                        setStarFlagOfHnad={this.props.setStarFlagOfHnad}
                                                        handReplayerOpen={this.props.handReplayerOpen}
                                                        openNotes={(hand) => { this.props.openNotes(hand) }} />)}
                                            </tbody>
                                        </MediaQuery>
                                        <MediaQuery maxWidth={767} >
                                            <tbody>
                                                {this.props.handList.map((hand, i) =>
                                                    <TableSmallBody key={i} hand={hand}
                                                        setStarFlagOfHnad={this.props.setStarFlagOfHnad}
                                                        handReplayerOpen={this.props.handReplayerOpen}
                                                        openNotes={(hand) => { this.props.openNotes(hand) }} />)}
                                            </tbody>
                                        </MediaQuery>
                                    </table>
                            }

                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default TopWonNLoss;


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/TopWonNLoss.js
 **/